import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ProductSlider.css"; // for custom styles

const ProductSlider = ({ images }) => {
  const settingsProduct = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="product-slider-wrapper">
      <Slider {...settingsProduct}>
        {images.map((img, index) => (
          <div key={index} className="slide-image-wrapper">
            <img
              src={process.env.REACT_APP_BACKEND_URL_IMAGES + img.imageUrl}
              alt={img.alt}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ProductSlider;
